"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _jsxFileName = "/builds/schumacherweb/devbridge/ui-shared/549481182/shared/src/theme/icons/files/scp-heal-logo.svg.js",
    _g,
    _defs;

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function ReactComponent(props) {
  return React.createElement("svg", (0, _extends2["default"])({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 5
    },
    __self: this
  }), _g || (_g = React.createElement("g", {
    clipPath: "url(#prefix__clip0_5452_34945)",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 13
    },
    __self: this
  }, React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.328 7a10.536 10.536 0 11.017 21.073A10.536 10.536 0 0130.328 7z",
    fill: "#1C3D6B",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 14
    },
    __self: this
  }), React.createElement("path", {
    d: "M1.15 22.287S-2.806 48.87 29.672 53.269c0 0-1.57-30.715-28.522-30.982z",
    fill: "#0D1F36",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 20
    },
    __self: this
  }), React.createElement("path", {
    d: "M58.85 22.287S62.83 48.87 30.328 53.269c0 0 1.588-30.715 28.522-30.982z",
    fill: "#B5BD00",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 24
    },
    __self: this
  }))), _defs || (_defs = React.createElement("defs", {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 29
    },
    __self: this
  }, React.createElement("clipPath", {
    id: "prefix__clip0_5452_34945",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 30
    },
    __self: this
  }, React.createElement("path", {
    fill: "#fff",
    transform: "translate(1 7)",
    d: "M0 0h58v46.269H0z",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 31
    },
    __self: this
  })))));
}

var _default = ReactComponent;
exports["default"] = _default;